import { BillingMode, InvoiceStatus, InvoiceType } from '../../../../../../services/exports/Constants';

export default {
  title: 'Facturen',
  form: {
    title: 'Nieuwe betaling aanvragen',
    company: {
      label: 'Restaurant',
    },
    billing_mode: {
      label: 'Factureringsbron',
    },
    billing_anchor: {
      label: 'Facturering starten op',
    },
    items: {
      label: 'Items',
    },
    name: {
      label: 'Naam',
      placeholder: '1000x Flyers',
    },
    net_amount: {
      label: 'Bedrag (netto)',
      tax_breakdown: '+{{tax}} btw = {{total}}',
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    name: 'Naam/Nummer',
    billing_mode: 'Factureringsbron',
    type: 'Type',
    status: 'Status',
    amount: 'Bedrag (bruto)',
    created_at: 'Aangemaakt',
    billing_anchor: 'Facturering vanaf',
    invoice: 'Factuur',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Betaalmethode',
    [BillingMode.InternalInvoicing]: 'Verkoop',
  },
  types: {
    [InvoiceType.Manual]: 'Handmatig',
    [InvoiceType.SetupFee]: 'Installatiekosten',
    [InvoiceType.Subscription]: 'Abonnement',
    [InvoiceType.SubscriptionBridge]: 'Abonnement (pro rata tot de 5e)',
    [InvoiceType.SubscriptionProration]: 'Abonnement (pro rata upgrade)',
  },
  statuses: {
    [InvoiceStatus.Pending]: 'In behandeling',
    [InvoiceStatus.Processing]: 'Verwerken',
    [InvoiceStatus.Paid]: 'Betaald',
    [InvoiceStatus.PartiallyRefunded]: 'Gedeeltelijk terugbetaald',
    [InvoiceStatus.Refunded]: 'Terugbetaald',
    [InvoiceStatus.Failed]: 'Mislukt',
  },
  modals: {
    invoice_creation_confirmation: {
      title: 'Weet u zeker dat u een factuur wilt aanmaken voor {{amount}} netto aan {{company}} via {{billingMode}}?',
    },
    invoice_recharge_confirmation: {
      title: 'Weet u het zeker?',
      description:
        '<strong>{{company}}</strong> wordt <strong>{{amount}} bruto + boete bij betalingsfout indien van toepassing</strong> opnieuw afgeschreven via de primaire betaalmethode voor factuur {{details}}',
      recharge_failed: {
        title: 'Stripe heeft de betaling geweigerd',
        convert_hint:
          'U kunt deze factuur ook innen via de restaurantverkopen. De Stripe-factuur wordt nietig verklaard en het openstaande bedrag wordt afgetrokken van komende uitbetalingen.',
      },
    },
  },
  buttons: {
    show_transfers: 'Transfers tonen',
    hide_transfers: 'Transfers verbergen',
    create: 'Aanmaken',
    download_pdf: 'PDF downloaden',
    open_payment_page: 'Betalingspagina openen',
    open_invoice_page: 'Factuurdetails openen',
    add_item: 'Item toevoegen',
    convert_to_internal_billing: 'Innen via verkopen',
    recharge_invoice: 'Factuur opnieuw afschrijven',
  },
  toasts: {
    failed_to_load_data: 'Gegevens laden mislukt',
    failed_to_create_invoice: 'Factuur aanmaken mislukt!',
    invoice_got_created: 'Factuur aangemaakt!',
    invoice_got_recharged: 'Factuur opnieuw afgeschreven. Nieuwe betaling wordt verwerkt!',
    failed_to_recharge_invoice: 'Factuur opnieuw afschrijven mislukt!',
    invoice_got_converted_to_internal_billing:
      'Factuur omgezet naar verkoopfacturering. Het openstaande bedrag wordt afgetrokken van komende uitbetalingen.',
    failed_to_convert_invoice_to_internal_billing: 'Factuur omzetten naar verkoopfacturering mislukt!',
  },
};
